import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class UploadService {
    public uploadApi: string = "";

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public fileUpload(formData: any) {
        this.uploadApi =
            "/svcs/api/3.1/accounts/" +
            this.sharedService.accountUUID +
            "/events/" +
            this.sharedService.eventUUID +
            "/assetsv2";
        this.sharedService.isUpload = true;
        return this.http.post(this.uploadApi, formData, {
            observe: "response",
            headers: {}
        });
    }
}
